/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Templates_Delete_TitleInputs */

const en_event_templates_delete_title = /** @type {(inputs: Event_Templates_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Template`)
};

const fr_event_templates_delete_title = /** @type {(inputs: Event_Templates_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le modele`)
};

const de_event_templates_delete_title = /** @type {(inputs: Event_Templates_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlage löschen`)
};

const it_event_templates_delete_title = /** @type {(inputs: Event_Templates_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina modello`)
};

const ru_event_templates_delete_title = /** @type {(inputs: Event_Templates_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить шаблон`)
};

const es_event_templates_delete_title = /** @type {(inputs: Event_Templates_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar plantilla`)
};

const zh_cn2_event_templates_delete_title = /** @type {(inputs: Event_Templates_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除模板`)
};

const ja_event_templates_delete_title = /** @type {(inputs: Event_Templates_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テンプレートを削除`)
};

const hi_event_templates_delete_title = /** @type {(inputs: Event_Templates_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेम्पलेट हटाएं`)
};

const pt_pt2_event_templates_delete_title = /** @type {(inputs: Event_Templates_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir modelo`)
};

/**
* | output |
* | --- |
* | "Delete Template" |
*
* @param {Event_Templates_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_templates_delete_title = /** @type {((inputs?: Event_Templates_Delete_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Templates_Delete_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_templates_delete_title(inputs)
	if (locale === "de") return de_event_templates_delete_title(inputs)
	if (locale === "it") return it_event_templates_delete_title(inputs)
	if (locale === "ru") return ru_event_templates_delete_title(inputs)
	if (locale === "es") return es_event_templates_delete_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_templates_delete_title(inputs)
	if (locale === "ja") return ja_event_templates_delete_title(inputs)
	if (locale === "hi") return hi_event_templates_delete_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_templates_delete_title(inputs)
	return en_event_templates_delete_title(inputs)
});